<template>
    <v-container fluid>
        <v-overlay :value="isLoading" absolute>
            <v-progress-circular :size="70" :width="7" indeterminate></v-progress-circular>
        </v-overlay>
        <!-- ============================================================================================================================ -->
        <h2 class="white--text text-center">{{ myInfo.site_name }} : {{ myInfo.user_name }}</h2>
        <h6 class="white--text text-center">Logged in at {{ $moment.unix(myInfo.iat).format("HH:mm:ss") }}</h6>
        <!-- ============================================================================================================================ -->
        <div class="my-2 text-right">
            <v-btn @click="getLoginUsers()">現在{{ dbUsers.length }}人ログイン中 <v-icon class="ml-5">mdi-cached</v-icon></v-btn>
        </div>
        <!-- ============================================================================================================================ -->
        <v-expansion-panels accordion v-model="grpPanel">
            <v-expansion-panel v-for="group in groupedDevices" :key="group.name">
                <v-expansion-panel-header class="grey">
                    <h3 class="white--text">
                        {{ group.name }}
                        <span class="ml-2 white--text">({{ group.devices.length }}台)</span>
                    </h3>
                </v-expansion-panel-header>

                <v-expansion-panel-content class="grey lighten-1 pt-5">
                    <v-row>
                        <v-col v-for="device of group.devices" :key="device.id" cols="12" sm="12" md="6" lg="4" xl="3">
                            <v-card>
                                <v-toolbar color="indigo" dark>
                                    <v-toolbar-title class="font-weight-bold">{{ device.name }}</v-toolbar-title>
                                </v-toolbar>
                                <v-card-text>
                                    <!-- ---------------------------- -->
                                    <v-divider class="my-3"></v-divider>
                                    <v-row>
                                        <v-col cols="5">
                                            <h2 class="ml-5">【 状態 】</h2>
                                        </v-col>
                                        <v-col>
                                            <h4 class="mt-3 text-right">{{ timeFormat(device.alived_at) }}</h4>
                                        </v-col>
                                    </v-row>
                                    <v-chip class="ma-1" :color="successStatusColor(device.feederStatus.standby)" text-color="white"><h4>稼働中</h4></v-chip>
                                    <v-chip class="ma-1" :color="successStatusColor(device.feederStatus.oparating || device.feederStatus.oparating_ai)" text-color="white"><h4>プラン実行中</h4></v-chip>
                                    <v-chip class="ma-1" :color="errorStatusColor(device.feederStatus.err_serial)" text-color="white"><h4>シリアル</h4></v-chip>
                                    <v-chip class="ma-1" :color="errorStatusColor(device.feederStatus.err_feed_motor)" text-color="white"><h4>モーター1</h4></v-chip>
                                    <v-chip class="ma-1" :color="errorStatusColor(device.feederStatus.err_sprinkle_motor)" text-color="white"><h4>モーター2</h4></v-chip>
                                    <v-chip class="ma-1" :color="errorStatusColor(device.feederStatus.err_sensor1)" text-color="white"><h4>自発センサー1</h4></v-chip>
                                    <v-chip class="ma-1" :color="errorStatusColor(device.feederStatus.err_sensor2)" text-color="white"><h4>自発センサー2</h4></v-chip>
                                    <v-chip class="ma-1" :color="errorStatusColor(device.feederStatus.err_battery_low)" text-color="white"><h4>バッテリー</h4></v-chip>
                                    <!-- ---------------------------- -->
                                    <div v-show="device.feeder && device.feeder.is_stock_sensor">
                                        <div class="d-flex align-center mt-3">
                                            <h4>飼料残量:&nbsp;&nbsp;</h4>
                                            <v-progress-linear style="width: 150px" height="17" :value="device.feederStatus.stock_level" color="amber darken-4" @dblclick="dispStockAD = !dispStockAD">
                                                <strong v-show="!dispStockAD">{{ device.feederStatus.stock_level }} % </strong>
                                                <strong v-show="dispStockAD">{{ device.feederStatus.stock_adval }}</strong>
                                            </v-progress-linear>
                                        </div>
                                    </div>
                                    <div v-show="!(device.feeder && device.feeder.is_stock_sensor)">
                                        <div class="ma-4">&nbsp;</div>
                                    </div>
                                    <!-- ---------------------------- -->
                                    <v-expansion-panels class="mt-5">
                                        <v-expansion-panel>
                                            <v-expansion-panel-header><h3>（操作、カメラ、解析、情報）</h3></v-expansion-panel-header>
                                            <v-expansion-panel-content>
                                                <v-divider class="my-3"></v-divider>
                                                <h2 class="ml-5">【 操作 】</h2>
                                                <v-btn @click="publishMessage(device.mac, 'standby', 'on')" color="info" v-show="device.feeder_id" class="ma-2">
                                                    <v-icon>mdi-reload</v-icon>
                                                    <h4>稼働</h4>
                                                </v-btn>
                                                <v-btn @click="publishMessage(device.mac, 'standby', 'off')" color="info" v-show="device.feeder_id" class="ma-2">
                                                    <v-icon>mdi-pause</v-icon>
                                                    <h4>休止</h4>
                                                </v-btn>
                                                <v-btn @click="publishMessage(device.mac, 'err', 'reset')" color="info" v-show="device.feeder_id" class="ma-2">
                                                    <v-icon>mdi-check</v-icon>
                                                    <h4>エラーリセット</h4>
                                                </v-btn>
                                                <!--
                                                <v-btn :to="{ name: 'FeedPlan', params: { device_id: device.id } }" color="info" v-show="device.feeder_id" class="ma-2">
                                                    <v-icon>mdi-calendar-clock</v-icon>
                                                    <h4>給餌プラン(旧版)</h4>
                                                </v-btn>
                                                -->
                                                <v-btn color="info" v-show="device.feeder_id" class="ma-2" @click="openFeedPlan(device.id)">
                                                    <v-icon>mdi-calendar-clock</v-icon>
                                                    <h4>給餌プラン</h4>
                                                </v-btn>
                                                <!-- ---------------------------- -->
                                                <v-divider class="my-3"></v-divider>
                                                <h2 class="ml-5">【 カメラ 】</h2>
                                                <div v-show="device.sd_ver < '20230614'">
                                                    <v-btn :to="{ name: 'LiveCam', params: { device_id: device.id, feeder_id: device.feeder_id, camera_id: device.camera1_id } }" color="info" v-show="device.camera1_id" class="ma-2">
                                                        <v-icon>mdi-camera</v-icon>
                                                        <h4>カメラ1</h4>
                                                    </v-btn>
                                                    <v-btn :to="{ name: 'LiveCam', params: { device_id: device.id, feeder_id: device.feeder_id, camera_id: device.camera2_id } }" color="info" v-show="device.camera2_id" class="ma-2">
                                                        <v-icon>mdi-camera</v-icon>
                                                        <h4>カメラ2</h4>
                                                    </v-btn>
                                                    <v-btn :to="{ name: 'LiveCam', params: { device_id: device.id, feeder_id: device.feeder_id, camera_id: device.camera3_id } }" color="info" v-show="device.camera3_id" class="ma-2">
                                                        <v-icon>mdi-camera</v-icon>
                                                        <h4>カメラ3</h4>
                                                    </v-btn>
                                                    <v-btn :to="{ name: 'LiveCam', params: { device_id: device.id, feeder_id: device.feeder_id, camera_id: device.camera4_id } }" color="info" v-show="device.camera4_id" class="ma-2">
                                                        <v-icon>mdi-camera</v-icon>
                                                        <h4>カメラ4</h4>
                                                    </v-btn>
                                                </div>
                                                <div v-show="device.sd_ver >= '20230614'">
                                                    <v-btn color="info" class="ma-2" @click="openLiveCam(device.id, device.feeder_id, device.camera1_id, device.feederStatus.total_weight)" v-show="device.camera1_id">
                                                        <v-icon>mdi-video</v-icon>
                                                        <h4>カメラ1</h4>
                                                    </v-btn>
                                                    <v-btn color="info" class="ma-2" @click="openLiveCam(device.id, device.feeder_id, device.camera2_id, device.feederStatus.total_weight)" v-show="device.camera2_id">
                                                        <v-icon>mdi-video</v-icon>
                                                        <h4>カメラ2</h4>
                                                    </v-btn>
                                                    <v-btn color="info" class="ma-2" @click="openLiveCam(device.id, device.feeder_id, device.camera3_id, device.feederStatus.total_weight)" v-show="device.camera3_id">
                                                        <v-icon>mdi-video</v-icon>
                                                        <h4>カメラ3</h4>
                                                    </v-btn>
                                                    <v-btn color="info" class="ma-2" @click="openLiveCam(device.id, device.feeder_id, device.camera4_id, device.feederStatus.total_weight)" v-show="device.camera4_id">
                                                        <v-icon>mdi-video</v-icon>
                                                        <h4>カメラ4</h4>
                                                    </v-btn>
                                                    <!--
                                                    <v-btn :to="{ name: 'LiveCamDrt', params: { device_id: device.id, feeder_id: device.feeder_id, camera_id: device.camera1_id } }" color="info" v-show="device.camera1_id" class="ma-2">
                                                        <v-icon>mdi-video</v-icon>
                                                        <h4>カメラ1(旧版)</h4>
                                                    </v-btn>
                                                    <v-btn :to="{ name: 'LiveCamDrt', params: { device_id: device.id, feeder_id: device.feeder_id, camera_id: device.camera2_id } }" color="info" v-show="device.camera2_id" class="ma-2">
                                                        <v-icon>mdi-video</v-icon>
                                                        <h4>カメラ2(旧版)</h4>
                                                    </v-btn>
                                                    <v-btn :to="{ name: 'LiveCamDrt', params: { device_id: device.id, feeder_id: device.feeder_id, camera_id: device.camera3_id } }" color="info" v-show="device.camera3_id" class="ma-2">
                                                        <v-icon>mdi-video</v-icon>
                                                        <h4>カメラ3(旧版)</h4>
                                                    </v-btn>
                                                    <v-btn :to="{ name: 'LiveCamDrt', params: { device_id: device.id, feeder_id: device.feeder_id, camera_id: device.camera4_id } }" color="info" v-show="device.camera4_id" class="ma-2">
                                                        <v-icon>mdi-video</v-icon>
                                                        <h4>カメラ4(旧版)</h4>
                                                    </v-btn>
                                                    -->
                                                    <v-btn :to="{ name: 'LiveAiCam', params: { device_id: device.id, camera_id: device.ai_camera_id } }" color="info" v-show="device.ai_camera_id" class="ma-2">
                                                        <v-icon>mdi-camera</v-icon>
                                                        <h4>AI カメラ</h4>
                                                    </v-btn>
                                                </div>
                                                <!-- ---------------------------- -->
                                                <v-divider class="my-3"></v-divider>
                                                <h2 class="ml-5">【 解析 】</h2>
                                                <v-btn :to="{ name: 'DeviceChart', params: { device_id: device.id } }" color="info" v-show="device.feeder_id" class="ma-2">
                                                    <v-icon>mdi-chart-bar</v-icon>
                                                    <h4>グラフ</h4>
                                                </v-btn>
                                                <!-- ---------------------------- -->
                                                <v-divider class="my-3"></v-divider>
                                                <h2 class="ml-5">【 情報 】</h2>
                                                <h4>本日給餌量：{{ sfsFloatFormat(device.feederStatus.total_weight) }} kg</h4>
                                                <h4 v-show="device.feeder && device.feeder.is_react">本日自発回数：{{ sfsNumberFormat(device.feederStatus.total_react) }} 回</h4>
                                                <h4 v-show="device.sensor && device.sensor.is_water">水温：{{ sfsFloatFormat(device.feederStatus.water) }} ℃</h4>
                                                <h4 v-show="device.sensor && device.sensor.is_temp">気温：{{ sfsFloatFormat(device.feederStatus.temp) }} ℃</h4>
                                                <h4 v-show="device.sensor && device.sensor.is_solar">日射量：{{ sfsFloatFormat(device.feederStatus.solar) }} W/㎡</h4>
                                                <h4 v-show="device.sensor && device.sensor.is_oxygen">溶存酸素：{{ sfsFloatFormat(device.feederStatus.oxygen) }} mg/L</h4>
                                                <h4 v-show="device.sensor && device.sensor.is_salinity">塩分濃度：{{ sfsFloatFormat(device.feederStatus.salinity) }} ％</h4>
                                                <h4>バッテリー：{{ sfsFloatFormat(device.feederStatus.battery_volt) }} V</h4>
                                                <!-- ---------------------------- -->
                                                <!--
                                                <div class="d-flex align-center">
                                                    <h4>飼料残量:&nbsp;&nbsp;</h4>
                                                    <v-progress-linear style="width: 150px" height="17" :value="device.feederStatus.stock_level" color="amber darken-4">
                                                        <strong>{{ device.feederStatus.stock_level }} %</strong>
                                                    </v-progress-linear>
                                                </div>
                                                <v-divider class="my-3"></v-divider>
                                                -->
                                                <!-- ------------------- -->
                                                <v-divider class="my-5"></v-divider>
                                                <v-row>
                                                    <v-col>
                                                        <h4 class="mt-3" @dblclick="viewCmd = !viewCmd">Ver:{{ device.feederStatus.version }}</h4>
                                                    </v-col>
                                                    <v-col>
                                                        <h4 class="mt-3 text-right">{{ timeFormat(device.alived_at) }}</h4>
                                                    </v-col>
                                                </v-row>
                                                <!-- ------------------- -->
                                                <v-divider class="my-5"></v-divider>
                                                <v-row v-show="viewCmd">
                                                    <v-col>
                                                        <div v-for="(device, index) in device.feederStatus.cmd" :key="index">
                                                            <span>{{ index }}：{{ device }}</span>
                                                        </div>
                                                    </v-col>
                                                </v-row>
                                                <!-- ------------------- -->
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>
                                    </v-expansion-panels>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        <!-- ============================================================================================================================ -->
        <v-dialog v-model="feedPlanDialog" fullscreen>
            <v-card>
                <v-toolbar color="primary" dark>
                    <v-toolbar-title>給餌プラン</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="feedPlanDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <feed-plan :device_id="dlg_device_id" v-if="feedPlanDialog"></feed-plan>
            </v-card>
        </v-dialog>
        <!-- ============================================================================================================================ -->
        <v-dialog v-model="liveCamDialog" fullscreen>
            <v-card>
                <v-toolbar color="primary" dark>
                    <v-toolbar-title> Live Camera </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="liveCamDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <comp-live-cam :device_id="dlg_device_id" :feeder_id="dlg_feeder_id" :camera_id="dlg_camera_id" :total_weight="dlg_total_weight" v-if="liveCamDialog"></comp-live-cam>
            </v-card>
        </v-dialog>
        <!-- ============================================================================================================================ -->
    </v-container>
</template>

<script>
// @ is an alias to /src
import Config from "@/config.json";
import mqtt from "mqtt";
import FeedPlan from "@/components/CompFeedPlan.vue";
import CompLiveCam from "@/components/CompLiveCam.vue";
export default {
    name: "DevicesList",
    components: {
        FeedPlan,
        CompLiveCam,
    },
    //========================================================
    data() {
        return {
            jwt: "",
            myInfo: [],
            dbSite: { id: 0, name: "" },
            dbUsers: [],
            dbDevices: [],
            dbFeeders: [],
            dbSensors: [],
            //-----------------------------
            mqttHost: Config.mqttHost,
            mqttID: Config.mqttID,
            mqttPW: Config.mqttPW,
            mqttTopicPub: Config.mqttTopicPub,
            mqttTopicSub: Config.mqttTopicSub,
            mac: "ff:ff:ff:ff:ff:ff", //"b8:27:eb:e5:25:c0",
            mqttClient: { connected: false },
            //-----------------------------
            grpPanel: 0,
            //-----------------------------
            dispStockAD: false,
            //-----------------------------
            isLoading: false,
            viewCmd: false,
            //-----------------------------
            feedPlanDialog: false,
            liveCamDialog: false,
            dlg_device_id: null,
            dlg_feeder_id: null,
            dlg_camera_id: null,
            dlg_total_weight: null,
            //-----------------------------
        };
    },
    //========================================================
    created: async function () {
        this.jwt = this.$localStorage.get("jwt");
        if (!this.jwt) {
            this.$router.push({ name: "Login" });
            return;
        }
        this.myInfo = this.$jwt.decode(this.jwt);
        if (this.myInfo && this.myInfo.exp < this.$moment().unix()) {
            this.$router.push({ name: "Login" });
            return;
        }
        //-----------------------
        this.isLoading = true;
        //-----------------------
        //非同期でAxiosGet
        this.putUserOperated();
        //const promiseSite = this.getSites();
        const promiseDevices = this.getDevices();
        const promiseFeeders = this.getFeeders();
        const promiseSensors = this.getSensors();
        //-----------------------
        //上記の終了を待つ
        //await promiseSite;
        await promiseDevices;
        await promiseFeeders;
        await promiseSensors;
        //-----------------------
        //上記が全て取得終了したタイミングで、配列マージする
        //await new Promise((r) => setTimeout(r, 500));
        this.mergeDeviceFeederSensor();
        //-----------------------
        await new Promise((r) => setTimeout(r, 500));
        this.connectMqtt();
        //-----------------------
        window.scrollTo(0, 0);
        //-----------------------
        await new Promise((r) => setTimeout(r, 500));
        this.getLoginUsers();
        //-----------------------
        this.isLoading = false;
    },
    //========================================================
    beforeDestroy: async function () {
        this.disconnectMqtt();
    },
    //========================================================
    computed: {
        groupedDevices() {
            const groups = {};
            this.dbDevices.forEach((device) => {
                const name = device.grp_name || "グループ未設定";
                if (!groups[name]) {
                    groups[name] = [];
                }
                groups[name].push(device);
            });
            return Object.keys(groups).map((name) => ({
                name: name,
                devices: groups[name],
            }));
        },
    },
    //========================================================
    methods: {
        //====================================================
        async getSites() {
            await this.axios({
                method: "GET",
                url: "/web/api/sites",
                //params: { id: this.myInfo.site_id },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbSite = response.data.json[0];
            });
        },
        //====================================================
        async getLoginUsers() {
            //------------------------------------------------
            this.isLoading = true;
            await new Promise((r) => setTimeout(r, 1000));
            //------------------------------------------------
            await this.axios({
                method: "GET",
                url: "/web/api/users",
                params: {
                    _fields: "id,name",
                    "operated_at[GREAT]": this.$moment().add(-30, "minutes").format("YYYY-MM-DD HH:mm"),
                },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbUsers = response.data.json;
            });
            //------------------------------------------------
            this.isLoading = false;
            //------------------------------------------------
        },
        //====================================================
        async getDevices() {
            await this.axios({
                method: "GET",
                url: "/web/api/devices",
                params: { "_order[sort_no]": "asc" },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbDevices = response.data.json;
                for (let i in this.dbDevices) {
                    this.dbDevices[i]["feederStatus"] = { stock_level: null, stock_adval: null };
                }
            });
        },
        //====================================================
        async getFeeders() {
            await this.axios({
                method: "GET",
                url: "/web/api/feeders",
                //params: { id: this.feeder_id, },
                params: { "_order[sort_no]": "asc" },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbFeeders = response.data.json;
                for (let i in this.dbFeeders) {
                    const otpStr = this.dbFeeders[i]["option_json"];
                    let opt = {};
                    try {
                        opt = JSON.parse(otpStr);
                    } catch {
                        self.console.log("json parse error");
                    }
                    if (opt["stock_sensor"]) {
                        this.dbFeeders[i]["is_stock_sensor"] = true;
                    } else {
                        this.dbFeeders[i]["is_stock_sensor"] = false;
                    }
                }
            });
        },
        //====================================================
        async getSensors() {
            await this.axios({
                method: "GET",
                url: "/web/api/sensors",
                params: { "_order[sort_no]": "asc" },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbSensors = response.data.json;
                // for (let i in this.dbSensors) {
                //     this.dbDevices[i]["feederStatus"] = {};
                // }
            });
        },
        //====================================================
        mergeDeviceFeederSensor() {
            for (let i in this.dbDevices) {
                for (let j in this.dbFeeders) {
                    if (this.dbDevices[i]["feeder_id"] == this.dbFeeders[j]["id"]) {
                        this.dbDevices[i]["feeder"] = this.dbFeeders[j];
                        break;
                    }
                }
                //-------------------------------
                for (let j in this.dbSensors) {
                    if (this.dbDevices[i]["sensor_id"] == this.dbSensors[j]["id"]) {
                        this.dbDevices[i]["sensor"] = this.dbSensors[j];
                        break;
                    }
                }
            }
        },
        //====================================================
        chkAlive(alived_at) {
            if (!alived_at) return false;
            let now = this.$moment().add(-2, "hours");
            let alive = this.$moment(alived_at);
            if (now < alive) return false;
            return true;
        },
        //====================================================
        timeFormat(timeStr) {
            let ret = "";
            if (timeStr) ret = this.$moment(timeStr).format("YYYY/M/D HH:mm:ss");
            return ret;
        },
        //====================================================
        async connectMqtt() {
            //-----------------
            if (this.mqttClient.connected) return true;
            //-----------------
            const gThis = this;
            //-----------------
            this.mqttClient = mqtt.connect(
                this.mqttHost
                //{ username: this.mqttID, password: this.mqttPW }
            );
            //-----------------
            this.mqttClient.on("connect", function () {
                self.console.log("MQTT Connected !!");
            });
            //-----------------
            this.mqttClient.on("message", function (topic, message) {
                //gThis.subMessage = message.toString();
                //self.console.log(topic);
                //self.console.log(message.toString());
                let subMsg = message.toString();
                let obj = JSON.parse(subMsg);
                if (obj.type && obj.type == "alive" && obj.feederStatus) {
                    let mac = obj.mac;
                    let alived_at = obj.sent_at; //this.$moment().format("YYYY-MM-DD HH:mm:ss");
                    let feederStatus = obj["feederStatus"];
                    let standby = obj["feederStatus"]["standby"];
                    let err_serial = obj["feederStatus"]["err_serial"];
                    gThis.deviceStatusUpdate(mac, alived_at, feederStatus, standby, err_serial);
                }
            });
            //-----------------
            this.mqttClient.subscribe(this.mqttTopicSub + "/#");
        },
        //====================================================
        deviceStatusUpdate: async function (mac, alived_at, feederStatus, standby, err_serial) {
            for (let i in this.dbDevices) {
                if (mac == this.dbDevices[i]["mac"]) {
                    //-----------------------------------------------------
                    // ラズパイから送信してくる 残量AD値を、パーセントに変換する。
                    let stock_level = 0; //this.dbDevices[i]["feederStatus"]["stock_level"];
                    const stock_high = this.dbDevices[i]["feeder"]["stock_high"];
                    const stock_mid = this.dbDevices[i]["feeder"]["stock_mid"];
                    const stock_low = this.dbDevices[i]["feeder"]["stock_low"];
                    const stock_empty = this.dbDevices[i]["feeder"]["stock_empty"];
                    const ADval = Number(feederStatus.turbidity); //濁度のデータブロックを再利用。残量センサー値
                    if (ADval < stock_empty) stock_level = 25;
                    if (ADval < stock_low) stock_level = 50;
                    if (ADval < stock_mid) stock_level = 75;
                    if (ADval < stock_high) stock_level = 100;
                    if (!ADval) stock_level = null;
                    feederStatus["stock_level"] = stock_level;
                    feederStatus["stock_adval"] = ADval;
                    //-----------------------------------------------------
                    this.$set(this.dbDevices[i], "feederStatus", feederStatus);
                    this.$set(this.dbDevices[i], "alived_at", alived_at);
                    this.$set(this.dbDevices[i], "standby", standby);
                    this.$set(this.dbDevices[i], "err_serial", err_serial);
                    break;
                }
            }
        },
        //====================================================
        disconnectMqtt() {
            if (!this.mqttClient.connected) return true;
            this.mqttClient.end();
        },
        //====================================================
        publishMessage(mac, key, val) {
            const topic = this.mqttTopicPub + "/" + mac;
            const pubMessage = { type: "order", key: key, val: val, mac: mac };
            if (this.mqttClient.connected) {
                this.mqttClient.publish(topic, JSON.stringify(pubMessage));
            }
            this.putUserOperated();
        },
        //====================================================
        successStatusColor(val) {
            if (val == 1) return "green";
            else if (val == 0) return "gray";
            else return "gray";
        },
        //====================================================
        errorStatusColor(val) {
            if (val == 1) return "red";
            else if (val == 0) return "green";
            else return "gray";
        },
        //====================================================
        sfsNumberFormat(val) {
            let ret = "---";
            if (val || val == 0) {
                ret = Number(val);
            }
            return ret;
        },
        //====================================================
        sfsFloatFormat(val) {
            let ret = "---";
            if (val || val == 0) {
                ret = Math.floor(val * 10) / 10;
                ret = ret.toFixed(1);
            }
            return ret;
        },
        //====================================================
        putUserOperated() {
            this.axios({
                method: "PUT",
                url: "/web/api/user_operated",
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            });
        },
        //====================================================
        openFeedPlan(deviceId) {
            this.dlg_device_id = deviceId;
            this.feedPlanDialog = true;
        },
        //====================================================
        openLiveCam(deviceId, feederId, cameraId, total_weight) {
            this.dlg_device_id = deviceId;
            this.dlg_feeder_id = feederId;
            this.dlg_camera_id = cameraId;
            this.dlg_total_weight = total_weight;
            this.liveCamDialog = true;
        },
        //====================================================
    },
};
// alter table feeders add column has_m1sensor int default '0' after sort_no;
// alter table feeders add column has_m2sensor int default '0' after sort_no;
// alter table feeders add column has_loadcell int default '0' after sort_no;
</script>
